import { render, staticRenderFns } from "./create.modal.vue?vue&type=template&id=df0f1486&scoped=true"
import script from "./create.modal.vue?vue&type=script&lang=js"
export * from "./create.modal.vue?vue&type=script&lang=js"
import style0 from "./create.modal.vue?vue&type=style&index=0&id=df0f1486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0f1486",
  null
  
)

export default component.exports